module.exports = __webpack_public_path__ + "img/AR.bfb1c1db.svg";